import { IStore, IAction } from "store";
import { DealAction } from "../../actions";
import { ICommitment, IRound, ICreateFirstCommitmentResponse } from "../../types";
import { reducer } from "../index";

reducer.createHandler(
  DealAction.CreateCommitmentSuccess,
  (state: IStore, { payload }: IAction<ICommitment>): IStore => ({
    ...state,
    dealModule: {
      ...state.dealModule,
      deal: {
        ...state.dealModule.deal,
        rounds: state.dealModule.deal.rounds.map((round: IRound) => {
          if (round.id === payload.round_id) {
            return {
              ...round,
              deal_commitments: [...round.deal_commitments, payload]
            };
          }
          return round;
        })
      }
    }
  })
);

reducer.createHandler(
  DealAction.DeleteCommitmentSuccess,
  (state: IStore, { payload }: IAction<ICommitment>): IStore => ({
    ...state,
    dealModule: {
      ...state.dealModule,
      deal: {
        ...state.dealModule.deal,
        rounds: state.dealModule.deal.rounds.map((round: IRound) => {
          if (round.id === payload.round_id) {
            return {
              ...round,
              deal_commitments: round.deal_commitments.filter((commitment: ICommitment) => commitment.id !== payload.id)
            };
          }
          return round;
        })
      }
    }
  })
);

reducer.createHandler(
  DealAction.UpdateCommitmentSuccess,
  (state: IStore, { payload }: IAction<ICommitment>): IStore => {
    const { id, round_id } = payload;

    return {
      ...state,
      dealModule: {
        ...state.dealModule,
        deal: {
          ...state.dealModule.deal,
          rounds: state.dealModule.deal.rounds.map((round: IRound) => {
            if (round.id === round_id) {
              return {
                ...round,
                deal_commitments: round.deal_commitments?.map((commitment: ICommitment) => {
                  if (commitment.id === id) {
                    return {
                      ...commitment,
                      ...payload
                    };
                  }
                  return commitment;
                })
              };
            }
            return round;
          })
        }
      }
    };
  }
);

reducer.createHandler(
  DealAction.CreateFirstCommitmentSuccess,
  (state: IStore, { payload }: IAction<ICreateFirstCommitmentResponse>): IStore => ({
    ...state,
    dealModule: {
      ...state.dealModule,
      deal: {
        ...state.dealModule.deal,
        rounds: [...state.dealModule.deal.rounds, ...payload.round]
      }
    }
  })
);

reducer.createHandler(
  DealAction.ImportCommitmentSuccess,
  (state: IStore, { payload }: IAction<IRound[]>): IStore => ({
    ...state,
    dealModule: {
      ...state.dealModule,
      deal: {
        ...state.dealModule.deal,
        rounds: payload
        // rounds: [
        //   ...state.dealModule.deal.rounds.filter((round: IRound) =>
        //     payload.find((importedRound) => importedRound.id !== round.id)  if we add imported rounds separately and not all as a bunch
        //   ),
        //   ...payload,
        // ],
      }
    }
  })
);
